import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RegistryHelmet from '~/containers/RegistryHelmet';
import LoggedInHeader from '~/containers/LoggedInHeader';
import LoggedOutHeader from '~/components/LoggedOutHeader';
import SidebarNav from '~/sidebarNav/containers/SidebarNav';
import SearchBar from '~/search2/containers/SearchBar';
import Footer from '~/containers/Footer';
import Helpers from '~/utils/Helpers';
import '~/styles/veracode.styles.scss';
import '~/fonts/veracode.fonts.scss';

type AppProps = {
  myState: object;
  navigationState: object;
  location: object;
};
const App: React.SFC<AppProps> = props => {
  const { myState, navigationState: navState } = props;
  const { isLoggedIn, me = {} } = myState;
  const { activeState = {} } = navState;
  const { noSidebar = false, navMenu = '' } = activeState;
  // Legacy app.sourceclear, a user will not have an organization.
  function isLegacyView() {
    return me.organization === null;
  }
  return (
    <div
      className={classNames('veracode-theme', {
        'no-responsive': !isLoggedIn && (navMenu === 'library-view' || navMenu === 'artifact-view'),
      })}
    >
      <RegistryHelmet />
      <div className="flex flex--flex-direction--column height--100vh">
        <div className="flex--header">
          {isLoggedIn && !isLegacyView() && <LoggedInHeader location={props.location} />}
          {!isLoggedIn && <LoggedOutHeader location={props.location} />}
        </div>

        {noSidebar && (
          <div className="flex flex--content flex--justify-content--center">
            <div className="col-1-1">{props.children}</div>
          </div>
        )}

        {!noSidebar && (
          <div className="container flex flex--content">
            <div className="col-1-6 flex phone--hide">{!isLegacyView() && <SidebarNav />}</div>
            <div className="col-5-6 pl phone--col-1-1 phone--p0">
              <SearchBar />
              {props.children}
            </div>
          </div>
        )}

        <div className="flex--footer">
          <Footer />
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    myState: state.myState,
    navigationState: state.navigationState,
  };
}
export default connect(mapStateToProps)(App);
